import { Col, Form, Input, Modal, notification, Row, Switch } from 'antd';
import { CustomButton, CustomSelector } from '../../../components';
import React, { useEffect, useState } from 'react';
import MESSAGES from '../../../enums/Messages';
import { catchException } from '../../../utils/helpers/helpers';
import { createUnit, updateUnit } from '../../../api/module/unit';
import { getStructure, getStructureTypes } from '../../../api/module/structure';


const ModalStructure = ({ handleReset, onFinish, data, loading }) => {
  const [form] = Form.useForm();
  const [structureData, setStructureData] = useState({});

  const handleChangeStructure = async (value) => {
    try {
      let result = await getStructure(value);
      setStructureData(result.data);
    } catch (error) {
      catchException(error);
    }
  }

  useEffect(() => {
    if (Object.keys(data).length !== 0) {
      handleChangeStructure(data.tipo_estructura).then(r => {});
    }
  }, [])

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        name="unitForm"
        onFinish={onFinish}
        initialValues={data}
        preserve={false}
      >
        <Row gutter={40}>
          <Col span={24}>
            <Form.Item
              label="Tipo de unidad:"
              name="tipo_estructura"
              rules={[
                { required: true, message: 'Por favor ingrese un tipo de estructura' },
              ]}
            >
              <CustomSelector
                selectorProps={{
                  label: "Tipo de unidad:",
                  style: { width: '100%' },
                  placeholder:
                    'Seleccione el tipo de unidad... ',
                }}
                endpointFetch={async () => {
                  return await getStructureTypes();
                }}
                initialValue={data.tipo_estructura}
                onChange={handleChangeStructure}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify={'space-between'}>
          <Col span={12}>
            <Form.Item
              label={`Detalle 1 / ${structureData.detalle1 ?? ''}:`}
              name="detalle1"
              rules={[
                { required: true, message: 'Por favor ingrese un detalle' },
                { max: 100, message: 'El detalle no puede tener más de 100 caracteres' }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={`Detalle 2 / ${structureData.detalle2 ?? ''}:`}
              name="detalle2"
              rules={[
                { max: 100, message: 'El detalle no puede tener más de 100 caracteres' }
              ]}
              hidden={structureData?.detalle2 === null}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify={'space-between'}>
          <Col span={12}>
            <Form.Item
              label={`Detalle 3 / ${structureData.detalle3 ?? ''}:`}
              name="detalle3"
              rules={[
                { max: 100, message: 'El detalle no puede tener más de 100 caracteres' }
              ]}
              hidden={structureData?.detalle3 === null}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={`Detalle 4 / ${structureData.detalle4 ?? ''}:`}
              name="detalle4"
              rules={[
                { max: 100, message: 'El detalle no puede tener más de 100 caracteres' }
              ]}
              hidden={structureData?.detalle4 === null}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify={'space-between'}>
          <Col span={24}>
            <Form.Item
              label='Activo:'
              name='activo'
              valuePropName='checked'
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <Row justify={'center'}>
          <Col span={3}>
            <Form.Item>
              <CustomButton
                type="primary"
                htmlType="submit"
                text='Guardar'
                loading={loading}
              />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item>
              <CustomButton
                type="default"
                htmlType="button"
                text="Volver"
                onClick={() => {
                  form.resetFields();
                  handleReset();
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>);
}

export default function CreateUpdateUnit({project, parentModalUnit, responseUnit, dataUnit = {}}) {
  const [modalUnit, setModalUnit] = useState(true);
  const [isEditing, setIsEditing] = useState(dataUnit.size > 0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(dataUnit);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (!isEditing) {
        values.proyecto = project;
        await createUnit(values);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
      } else {
        values.proyecto = project;
        await updateUnit(data.id, values);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
      }
    } catch (error) {
      catchException(error);
    } finally {
      handleReset();
      responseUnit();
      parentModalUnit(false);
      setLoading(false);
    }
  };

  const handleReset = () => {
    setData({});
    setIsEditing(false);
    setModalUnit(false);
    parentModalUnit(false);
    responseUnit();
  };

  return (
    <Modal
      title={isEditing ? 'Editar Unidad' : 'Agregar Unidad'}
      open={modalUnit}
      onCancel={handleReset}
      footer={null}
      width={'70%'}
      destroyOnClose
    >
      <ModalStructure
        onFinish={onFinish}
        data={data}
        loading={loading}
        handleReset={handleReset}
      />
    </Modal>
  );
}
